// src/services/publicSiteWebService.js
import axios from 'axios';
import { baseURL } from '../utils/config';

// Créer une instance axios pour les appels publics
const publicApi = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Service pour les endpoints publics du site web
 * Ces endpoints sont accessibles sans authentification
 */
export const publicSiteWebService = {
  /**
   * Récupère toutes les données publiques en un seul appel
   * (paramètres, fonctionnalités, statistiques, témoignages, contact)
   * GET /api/siteweb/public/parametres/
   */
  getPublicData: async () => {
    try {
      const response = await publicApi.get('/siteweb/public/parametres/');
      return response.data;
    } catch (error) {
      console.error('Erreur lors du chargement des données publiques:', error);
      throw error;
    }
  },

  /**
   * Récupère un document légal par son type (cgu, confidentialite)
   * GET /api/siteweb/public/legal/<type_document>/
   */
  getDocumentLegal: async (typeDocument) => {
    try {
      const response = await publicApi.get(`/siteweb/public/legal/${typeDocument}/`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors du chargement du document ${typeDocument}:`, error);
      throw error;
    }
  },

  /**
   * Envoie une demande de contact
   * POST /api/siteweb/public/contact/
   */
  submitContact: async (data) => {
    try {
      const response = await publicApi.post('/siteweb/public/contact/', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'envoi du message:', error);
      throw error;
    }
  },



  
};

export default publicSiteWebService;